import { useThreadProvider } from 'cms/src/components/Comments/ThreadProvider';
import { useDrawer } from 'cms/src/components/Drawer';
import { TextSelection } from '@remirror/pm/state';
import { useEditorView } from '@remirror/react';
import { InlineCommentIcon } from '../../icons';
import CommandButton from '../CommandButton';
import React, { useCallback } from 'react';

export const InlineCommentButton = React.memo(({ isEditable }) => {
  const view = useEditorView();
  const { registerThread } = useThreadProvider();
  const { onOpen } = useDrawer();

  const onClickHandler = useCallback(() => {
    const { selection, schema } = view.state;
    const { empty, from, to } = selection;

    if (empty || from === to) return;
    const content = selection.content().toJSON();

    registerThread({
      subject: content,
      position: { from, to },
      onSuccess: (id) => {
        const markType = schema.marks.inlineComment;
        const mark = markType.create({ threadId: id });
        view.dispatch(view.state.tr.addMark(from, to, mark));
        view.dispatch(view.state.tr.setSelection(TextSelection.create(view.state.doc, 0)));
        view.focus();
        if (!isEditable) {
          const ce = new CustomEvent('saveFileData', { detail: { external: true } });
          window.dispatchEvent(ce);
        }
      },
    });
    onOpen();
  }, [view, isEditable]);

  return (
    <CommandButton
      label={'Comment'}
      labelOptions={{ className: 'weight-normal' }}
      icon={<InlineCommentIcon />}
      enabled={true}
      onClick={onClickHandler}
    />
  );
});

export default InlineCommentButton;
